import { useEffect, useState } from "react";
import { Col, InputGroup, Row } from "react-bootstrap";
import Navbar from "./Navbar";
import Form from "react-bootstrap/Form";
import earth from "../assets/planet-earth.svg";
import cricket from "../assets/cricket.svg";
import bollywood from "../assets/video-camera.svg";
import business from "../assets/portfolio.svg";
import history from "../assets/history.svg";
import laptop from "../assets/laptop.svg";
import science from "../assets/science.svg";
import flight from "../assets/flight.svg";
import book from "../assets/book.svg";
import knowledge from "../assets/light-bulb.svg";
import paint from "../assets/paint-palette.svg";
import music from "../assets/music.svg";
import food from "../assets/fast-food.svg"
import coin from "../assets/coin.png";
import apps from '../assets/apps.svg';
import game from '../assets/game.svg';
import andriod from '../assets/android.svg';
import ios from '../assets/ios.svg';
import shareit from '../assets/shareit-icon.svg';
import minecraft from '../assets/minecraft.svg';
import mobilegame from '../assets/mobile-game.svg';
import webgame from '../assets/web-game.svg';
import fileshare from '../assets/shared-folder.svg'
import stalking from '../assets/stalking.svg'
import ai from '../assets/ai.svg'
import finance from '../assets/finance.svg'
import { useNavigate } from "react-router-dom";
import Adsense from "./Adsense";
import AdRewardModal from "./AdRewardModal";
import { getCoins, addCoins, ENTRY_FEE } from "../utils/coins";

function Categories() {
  const [search, setSearch] = useState("");
  const [showAd, setShowAd] = useState(false);
 const navigate = useNavigate();

  // Entering a contest costs ENTRY_FEE coins. If the user can't afford it,
  // show the rewarded-ad popup so they can earn coins instead.
  const handleEnterCategory = (catName) => {
    if (getCoins() >= ENTRY_FEE) {
      addCoins(-ENTRY_FEE);
      navigate(`/category/${catName}`);
    } else {
      setShowAd(true);
    }
  };


  const categoriesData = [
     {name:"apps", icon:apps ,title:"Apps"},
    {name:"games", icon:game ,title:"Games"},
    {name:"android-apps", icon:andriod ,title:"Android Apps"},
    {name:"ios-apps", icon:ios ,title:"iOS Apps"},
    { name: "finance", icon: finance,title:"Finance" },
    {name:"web-games", icon:webgame ,title:"Web Games"},
    {name:"mobile-games", icon:mobilegame ,title:"Mobile Games"},
    {name:"minecraft-game", icon:minecraft ,title:"Minecraft"},
    {name:"shareit-app", icon:shareit ,title:"SHAREit App"},
    {name:"file-sharing", icon:fileshare ,title:"File Sharing"},
    {name:"cyber-security", icon:stalking ,title:"Cyber Security"},
    {name:"ai-quiz", icon:ai ,title:"AI Quiz"},
    { name: "general-knowledge", icon: knowledge,title:"General-Knowledge" },
    { name: "cricket", icon: cricket ,title:"Cricket"},
    { name: "bollywood", icon: bollywood ,title:"Bollywood"},
    { name: "history", icon: history ,title:"History"},
    { name: "business", icon: business,title:"Business" },
    { name: "technology", icon: laptop ,title:"Technology"},
    { name: "music", icon: music,title:"Music" },
    { name: "science", icon: science,title:"Science" },
    { name: "books", icon: book,title:"Books"},
    { name: "travel", icon: flight,title:"Travel" },
    { name: "art", icon: paint,title: "Art" },
    { name: "geography", icon: earth,title:"Geography" },
    { name: "food", icon: food,title:"Food" },
    

  ];

  const filteredCategories = categoriesData.filter((cat) =>
    cat.name.toLowerCase().includes(search.toLowerCase()),
  );
  return (
    <>
      <div className="main">
        <div className="main-div">
          <div className="container mt-2">
            <div className="mt-3">
              <Navbar />
            </div>
            <div className="mt-5">
              <div className="text-center">
                <h3>Quiz Categories </h3>
                <p>Choose a category and start earning coins</p>
              </div>
              <div className="mt-3">
                {/* <Form.Control type="text" placeholder="🔍 search category" /> */}
                <InputGroup className="mb-3">
                  <InputGroup.Text id="">🔍</InputGroup.Text>
                  <Form.Control
                    aria-label="Default"
                    aria-describedby="inputGroup-sizing-default"
                    placeholder="search category"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </InputGroup>
              </div>
              {/* <div>
             <Adsense slot="6300978111" />
              </div> */}
              <div className="mt-4 content-div">
                {/* <Row className="d-flex mt-4 g-3 mb-3">
                  <Col xs={12} md={6} className="">
                    <div className="card">
                      <div className="img-div">
                        <img
                          src={knowledge}
                          alt="knowledge"
                          style={{ height: "32px" }}
                        />
                      </div>
                      <h6 className="mt-3">General Knowledge</h6>
                      <p className="mb-0 para">Play and Win 2000</p>
                      <p className="mb-0 para">10 questions</p>
                      <p className="entry-text mb-0 mt-1">
                        entry{" "}
                        <span>
                          <img src={coin} style={{ height: "15px" }} alt="" />
                        </span>
                        100{" "}
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} md={6} className="">
                    <div className="card">
                      <div className="img-div">
                        <img
                          src={cricket}
                          alt="Cricket"
                          style={{ height: "35px" }}
                        />
                      </div>
                      <h6 className="mt-3">Cricket</h6>
                      <p className="mb-0 para">Play and Win 2000</p>
                      <p className="mb-0 para">10 questions</p>
                      <p className="entry-text mb-0 mt-2">
                        entry{" "}
                        <span>
                          <img src={coin} style={{ height: "15px" }} alt="" />
                        </span>
                        100
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} md={6} className="">
                    <div className="card">
                      <div className="img-div">
                        <img
                          src={bollywood}
                          alt="Bollywood"
                          style={{ height: "35px" }}
                        />
                      </div>
                      <h6 className="mt-3">Bollywood</h6>
                      <p className="mb-0 para">Play and Win 2000</p>
                      <p className="mb-0 para">10 questions</p>
                      <p className="entry-text mb-0 mt-2">
                        entry{" "}
                        <span>
                          <img src={coin} style={{ height: "15px" }} alt="" />
                        </span>
                        100
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} md={6} className="">
                    <div className="card">
                      <div className="img-div">
                        <img
                          src={history}
                          alt="history"
                          style={{ height: "35px" }}
                        />
                      </div>
                      <h6 className="mt-3">History</h6>
                      <p className="mb-0 para">Play and Win 2000</p>
                      <p className="mb-0 para">10 questions</p>
                      <p className="entry-text mb-0 mt-2">
                        entry{" "}
                        <span>
                          <img src={coin} style={{ height: "15px" }} alt="" />
                        </span>
                        100
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} md={6} className="">
                    <div className="card">
                      <div className="img-div">
                        <img
                          src={business}
                          alt="business"
                          style={{ height: "35px" }}
                        />
                      </div>
                      <h6 className="mt-3">Business</h6>
                      <p className="mb-0 para">Play and Win 2000</p>
                      <p className="mb-0 para">10 questions</p>
                      <p className="entry-text mb-0 mt-2">
                        entry{" "}
                        <span>
                          <img src={coin} style={{ height: "15px" }} alt="" />
                        </span>
                        100
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} md={6} className="">
                    <div className="card">
                      <div className="img-div">
                        <img
                          src={laptop}
                          alt="laptop"
                          style={{ height: "35px" }}
                        />
                      </div>
                      <h6 className="mt-3">Technology</h6>
                      <p className="mb-0 para">Play and Win 2000</p>
                      <p className="mb-0 para">10 questions</p>
                      <p className="entry-text mb-0 mt-2">
                        entry{" "}
                        <span>
                          <img src={coin} style={{ height: "15px" }} alt="" />
                        </span>
                        100
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} md={6} className="">
                    <div className="card">
                      <div className="img-div">
                        <img
                          src={music}
                          alt="music"
                          style={{ height: "35px" }}
                        />
                      </div>
                      <h6 className="mt-3">Music</h6>
                      <p className="mb-0 para">Play and Win 2000</p>
                      <p className="mb-0 para">10 questions</p>
                      <p className="entry-text mb-0 mt-2">
                        entry{" "}
                        <span>
                          <img src={coin} style={{ height: "15px" }} alt="" />
                        </span>
                        100
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} md={6} className="">
                    <div className="card">
                      <div className="img-div">
                        <img
                          src={science}
                          alt="science"
                          style={{ height: "35px" }}
                        />
                      </div>
                      <h6 className="mt-3">Science</h6>
                      <p className="mb-0 para">Play and Win 2000</p>
                      <p className="mb-0 para">10 questions</p>
                      <p className="entry-text mb-0 mt-2">
                        entry{" "}
                        <span>
                          <img src={coin} style={{ height: "15px" }} alt="" />
                        </span>
                        100
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} md={6} className="">
                    <div className="card">
                      <div className="img-div">
                        <img src={book} alt="book" style={{ height: "35px" }} />
                      </div>
                      <h6 className="mt-3">Books</h6>
                      <p className="mb-0 para">Play and Win 2000</p>
                      <p className="mb-0 para">10 questions</p>
                      <p className="entry-text mb-0 mt-2">
                        entry{" "}
                        <span>
                          <img src={coin} style={{ height: "15px" }} alt="" />
                        </span>
                        100
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} md={6} className="">
                    <div className="card">
                      <div className="img-div">
                        <img
                          src={flight}
                          alt="flight"
                          style={{ height: "35px" }}
                        />
                      </div>
                      <h6 className="mt-3">Travel</h6>
                      <p className="mb-0 para">Play and Win 2000</p>
                      <p className="mb-0 para">10 questions</p>
                      <p className="entry-text mb-0 mt-2">
                        entry{" "}
                        <span>
                          <img src={coin} style={{ height: "15px" }} alt="" />
                        </span>
                        100
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} md={6} className="">
                    <div className="card">
                      <div className="img-div">
                        <img
                          src={paint}
                          alt="paint"
                          style={{ height: "35px" }}
                        />
                      </div>
                      <h6 className="mt-3">Art</h6>
                      <p className="mb-0 para">Play and Win 2000</p>
                      <p className="mb-0 para">10 questions</p>
                      <p className="entry-text mb-0 mt-2">
                        entry{" "}
                        <span>
                          <img src={coin} style={{ height: "15px" }} alt="" />
                        </span>
                        100
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} md={6} className="">
                    <div className="card">
                      <div className="img-div">
                        <img
                          src={earth}
                          alt="earth"
                          style={{ height: "35px" }}
                        />
                      </div>
                      <h6 className="mt-3">Geography</h6>
                      <p className="mb-0 para">Play and Win 2000</p>
                      <p className="mb-0 para">10 questions</p>
                      <p className="entry-text mb-0 mt-2">
                        entry{" "}
                        <span>
                          <img src={coin} style={{ height: "15px" }} alt="" />
                        </span>
                        100
                      </p>
                    </div>
                  </Col>
                </Row> */}
                <Row className="d-flex mt-3 g-3 mb-3">
                  {filteredCategories.map((cat, index) => (
                    <Col xs={12} md={6} key={index}>
                      <div className="card " onClick={() => handleEnterCategory(cat.name)}>
                        <div className="img-div">
                          <img
                            src={cat.icon}
                            alt={cat.name}
                            style={{ height: "35px" }}
                          />
                        </div>
                        <h6 className="mt-3">{cat.title}</h6>
                        <p className="mb-0 para">Play and Win 1000</p>
                        <p className="mb-0 para">10 questions</p>
                        <p className="entry-text mb-0 mt-2">
                          entry{" "}
                          <span>
                            <img src={coin} style={{ height: "15px" }} alt="" />
                          </span>
                          100
                        </p>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AdRewardModal
        show={showAd}
        onClose={() => setShowAd(false)}
        message="You don't have enough coins to play this contest. Click on video ad to get 100 reward coins."
      />
    </>
  );
}

export default Categories;
